import { SortOptions } from '../../../ts/models/sort/CommonSortOptions';
import { OptionsDictionary } from '../../../ts/models/sort/SortOptionDefinitions';

export const dataRoleSortOptions: OptionsDictionary = {
  'name': SortOptions.name,
  'owner': SortOptions.owner,
  'containerName': SortOptions.containerName,
  'updated': SortOptions.updated,
};
